module.exports = __webpack_public_path__ + "static/media/John Mantione CAR-PAC video_1633099500672.430d4270.vtt";